import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HeightPage = lazy(() => import("./HeightPage"));

const HeightPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HeightPage />
    </Suspense>
  );
};

export default HeightPageLazy;
